<template>
  <div>
    <div class="right-title">
      <span>求职信详情</span>
      <div class="conten-btn-box">
        <el-button class="conter-btn" type="success" v-if="isShenhe" @click="shenhe(1)">通过</el-button>
        <el-button class="conter-btn" type="danger" v-if="isShenhe" @click="shenhe(2)">拒绝</el-button>
      </div>
      <el-button plain class="go-back" @click="goBack">返回</el-button>
    </div>
    <div class="content-box2">
      <div class="mode-box">
        <h2 class="title">{{title}}</h2>
        <div class="contents ql-editor" v-html="content"></div>
      </div>
    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    name: "hxrResume",
    data() {
      return {
        title:'',
        content:'',
        isShenhe: false,    //  是否显示审核
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      if (this.$route.query.shenhe) {
        this.isShenhe = true
      }
      // this.$emit('setType', 0)
      this.init()
    },
    methods: {
      init() {
        this.$api.apiContent.emailDetail({
          admin_id: this.user.id,
          id: this.$route.query.emailId
        })
          .then(res => {
            this.title = res.data.title
            this.content = res.data.content
        }).catch()
      },
      goBack() {     //  返回上一页
        this.$tools.goBack()
      },
      shenhe(state) {      //  1 通过 2 拒绝
        if(state === 1){
          this.$confirm('您确定要审核通过吗', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$api.apiContent.shenheQiuzhi({
              admin_id: this.user.id,
              coverLetterrId: this.$route.query.emailId,
              audit: state
            }).then(() => {
              this.$message.success('审核完成')
              this.goBack()
            }).catch(e => {
              this.$message.error(e.info)
            })

          }).catch()
        }else {
          this.$prompt('请填写拒绝理由', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(({value}) => {

            this.$api.apiContent.shenheQiuzhi({
              admin_id: this.user.id,
              coverLetterrId: this.$route.query.emailId,
              audit: state,
              delContent:value
            }).then(() => {
              this.$message.success('审核完成')
              this.goBack()
            }).catch(e => {
              this.$message.error(e.info)
            })
          }).catch();
        }
      }
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .right-title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .conten-btn-box {
      .conter-btn {
        height: 30px;
        padding: 0 15px;
      }
    }
  }

  .mode-box {
    padding: 20px;
    background: #fff;
    margin-bottom: 20px;
    min-height: 100%;
    .title{
      line-height: 40px;
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 20px;
      text-align: center;
    }
    .contents{

    }
  }
</style>